import React, { useState } from 'react';
import { Button as ButtonAnt, Typography, message } from 'antd';
import { UserOutlined, LockOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { GREE_1, GREE_3, WHITE, GRAY_3 } from '../utils/colors';
import { ROUTES } from '../constants/PathRoutes';
import SubBanner from "../components/SubBanner";
import Form from "../components/data_entry/form/Form";
import InputFormField from "../components/data_entry/form/InputFormField";
import PasswordFormField from "../components/data_entry/form/PasswordFormField";
import Button from "../components/data_entry/Button";
import axios from '../services/api';
import ENDPOINTS from '../constants/endpoints';
import { BuildFieldErrorsDict } from '../utils/utils';
import {useClientAuth} from "../contexts/ClientAuthContext";

const { Title, Text, Paragraph } = Typography;

const FIELD_NAMES = {
    EMAIL: 'email',
    PASSWORD: 'password',
};

const PageContainer = styled.div`
  display: flex;
  min-height: 80vh;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 32px;
  background: ${WHITE};
`;

const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 32px;
  background: linear-gradient(90deg, ${GREE_3} 0%, ${GREE_1} 100%);
  color: ${WHITE};
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 380px;
`;

const RightContent = styled.div`
  text-align: center;
  max-width: 400px;
`;

const RegisterButton = styled(ButtonAnt)`
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  margin-top: 24px;
  background: ${WHITE};
  color: ${GREE_1};
  border: none;
  font-weight: 600;

  &:hover {
    background: #f0f0f0 !important;
    color: ${GREE_1} !important;
  }
`;

export default function MemberArea() {
    const [form] = Form.useForm();
    const {login} = useClientAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            await login(values[FIELD_NAMES.EMAIL], values[FIELD_NAMES.PASSWORD]);
            message.success('Login realizado com sucesso!');
            navigate(ROUTES.LOJA_PRODUTOS);
        } catch (error) {
            BuildFieldErrorsDict(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/*<SubBanner title={'Notícias'} />*/}
            <PageContainer>

            <LeftPanel>
                <FormWrapper>
                    <Title level={2} style={{ color: GRAY_3, marginBottom: 8 }}>
                        Login
                    </Title>
                    <Text type="secondary" style={{ display: 'block', marginBottom: 32 }}>
                        Acesse sua conta para continuar
                    </Text>

                    <Form
                        form={form}
                        onFinish={onFinish}
                        autoComplete="off"
                    >
                        <InputFormField
                            form={{
                                label: "E-mail",
                                name: FIELD_NAMES.EMAIL,
                                rules: [
                                    { required: true, message: 'Por favor, insira seu e-mail!' },
                                    { type: 'email', message: 'E-mail inválido!' }
                                ]
                            }}
                            prefix={<UserOutlined />}
                            placeholder="seu@email.com"
                        />

                        <PasswordFormField
                            form={{
                                label: "Senha",
                                name: FIELD_NAMES.PASSWORD,
                                rules: [{ required: true, message: 'Por favor, insira sua senha!' }]
                            }}
                            prefix={<LockOutlined />}
                            placeholder="Sua senha"
                        />

                        <Form.Item>
                            <Button
                                htmlType="submit"
                                loading={loading}
                                block
                                size="large"
                            >
                                Entrar
                            </Button>
                        </Form.Item>
                    </Form>
                </FormWrapper>
            </LeftPanel>

            <RightPanel>
                <RightContent>
                    <ShoppingCartOutlined style={{ fontSize: 64, marginBottom: 24 }} />
                    <Title level={2} style={{ color: WHITE, marginBottom: 16 }}>
                        Esta é minha primeira compra
                    </Title>
                    <Paragraph style={{ color: 'rgba(255,255,255,0.85)', fontSize: 16, marginBottom: 32 }}>
                        O cadastro em nossa loja é simples e rápido.
                        Crie sua conta e aproveite todos os benefícios de ser um associado.
                    </Paragraph>
                    <RegisterButton
                        size="large"
                        block
                        onClick={() => navigate(ROUTES.AREA_ASSOCIADO_CADASTRO)}
                    >
                        Criar minha conta
                    </RegisterButton>
                </RightContent>
            </RightPanel>
        </PageContainer>
        </>

    );
}